import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import { DataGrid } from '@mui/x-data-grid';

const styles = {
  table: {
    '.MuiDataGrid-cellContent': {
      overflow: 'auto',
      textOverflow: 'inherit'
    }
  }
};
LRUSummaryTable.propTypes = {
  data: PropTypes.object
};
export default function LRUSummaryTable({ data }) {
  const [pageSize, setPageSize] = useState(5);
  const [lruList, setLruList] = useState([]);
  const getLRUs = (data) => {
    if (!data?.rack_details?.lrus) return [];
    return Object.entries(data.rack_details.lrus)
      .filter(([, lru]) => lru?.enabled === true)
      .map(([lruName, lru]) => ({
        id: lruName,
        name: lruName,
        units: lru.units,
        size: lru.size
      }));
  };

  useEffect(() => {
    const lrus = getLRUs(data);
    setLruList(lrus);
  }, [data]);
  const columns = [
    {
      field: 'name',
      headerName: 'Name',
      flex: 1
    },
    {
      field: 'units',
      headerName: 'Units',
      flex: 1
    },
    {
      field: 'size',
      headerName: 'Size',
      flex: 1
    }
  ];
  return (
    <Box>
      <DataGrid
        getRowId={(row) => row.id}
        rows={lruList}
        columns={columns}
        autoHeight
        pagination
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        rowsPerPageOptions={[5, 10, 20]}
        disableSelectionOnClick
        density="compact"
        sx={styles.table}
      />
    </Box>
  );
}
